import store from '@/store'
// import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

export const configTableAlumnosBajas = () => {
  const tableColumns = [
    { key: 'nombre', label: 'Datos del Alumno', sortable: true },
    { key: 'descripcion', label: 'Descripción', sortable: false },
    { key: 'opciones' },
  ]

  const configRequest = ref({
    wsParams: { action: 2, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsbajas', //* WebService name
    filterGetter: 'bajas/filterAlumnosB', //* Getter function to filter data
  })
  // *--------- UI --------*

  const resolveAlumnoTipoVariant = nombre => {
    if (nombre !== null) return 'warning'
    return 'primary'
  }
  return {
    tableColumns,
    configRequest,
    resolveAlumnoTipoVariant,
  }
}

export const useAluBajasCatalogos = () => ({

})
